import { React, useState, useEffect } from 'react'
import { useMutation } from '@apollo/client'
import Button from '@material-ui/core/Button'
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { setCoachingLeadContactMutation } from './mutations'

const MarkAsContactedDialog = ({
  open,
  onClose,
  contactMethodOptions = [],
  lead,
  refetch,
}) => {
  const { enqueueSnackbar } = useSnackbar()
  const [contactMethod, setContactMethod] = useState('')

  const [setCoachingLeadContact] = useMutation(setCoachingLeadContactMutation, {
    onCompleted: data => {
      const result = data?.setCoachingLeadContact
      if (result?.success) {
        enqueueSnackbar('Lead marked as contacted', { variant: 'success' })
        refetch?.()
        handleClose()
      } else {
        enqueueSnackbar(result?.message ?? 'Failed to mark lead as contacted', {
          variant: 'error',
        })
      }
    },
    onError: () => {
      enqueueSnackbar('Failed to mark lead as contacted', { variant: 'error' })
    },
  })

  useEffect(() => {
    if (!open) setContactMethod('')
  }, [open])

  const handleClose = () => {
    setContactMethod('')
    onClose()
  }

  const handleConfirm = () => {
    if (!lead?.id || !contactMethod) return
    setCoachingLeadContact({
      variables: { id: lead.id, contactMethod },
    })
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <>
        <DialogTitle>Mark as Contacted</DialogTitle>
        <DialogContent>
          <Typography>
            You're marking this lead as contacted outside of PGA Coach. How did
            you reach out?
          </Typography>
          <FormControl variant="outlined" fullWidth style={{ marginTop: 16 }}>
            <InputLabel id="mark-contacted-contact-method-label">
              Contact Method *
            </InputLabel>
            <Select
              labelId="mark-contacted-contact-method-label"
              value={contactMethod}
              onChange={e => setContactMethod(e.target.value)}
              label="Contact Method *"
            >
              {contactMethodOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleConfirm}
            disabled={!contactMethod}
            data-testid="mark-as-contacted-submit"
          >
            Mark as Contacted
          </Button>
        </DialogActions>
      </>
    </Dialog>
  )
}

export default MarkAsContactedDialog
